import { Component, Output, EventEmitter, Input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'chart-height',
    styleUrls: ['./chart-height.scss'],
    template: `
        <div id='chart-height' class="d-none d-md-block">
            <div class="card mb-2">
                <div class="card-header">
                    <button class="btn btn-info rounded-circle float-end"
                            ngbTooltip="{{ 'xml-report.chart.chartsize' | translate }}" placement="left"
                            (click)="showHeightSettings = !showHeightSettings;">
                        <i class='fas fa-lg fa-arrows-alt-v'></i>
                    </button>
                </div>
                <div class="card-body" [class.hide]="!showHeightSettings">
                    <div class="height-buttons float-end border">
                        <p class="mb-2 text-muted small font-weight-bold">{{ 'xml-report.chart.chartsize' | translate }}</p>
                        <a class="btn btn-sm btn-outline-primary rounded-circle text-btn" [class.active]="currentHeight=='S'" (click)="heightChange.emit('S')">S</a>
                        <a class="btn btn-sm btn-outline-primary rounded-circle text-btn" [class.active]="currentHeight=='M'" (click)="heightChange.emit('M')">M</a>
                        <a class="btn btn-sm btn-outline-primary rounded-circle text-btn" [class.active]="currentHeight=='L'" (click)="heightChange.emit('L')">L</a>
                        <a class="btn btn-sm btn-outline-primary rounded-circle text-btn" [class.active]="currentHeight=='XL'" (click)="heightChange.emit('XL')">XL</a>
                    </div>
                </div>
            </div>
        </div>
    `,
    host: { 'cid': 'ChartHeigt' },
    imports: [NgbTooltip, TranslatePipe]
})
export class ChartHeightComponent {
    @Input() currentHeight: string;
    @Output() heightChange = new EventEmitter();

    public showHeightSettings: boolean = false;
}
